export default [
	{ label: 'Season', key: 'season' },
	{ label: 'RegistrationOpensOn', key: 'registrationOpensOn' },
	{ label: 'FirstSemesterStartDate', key: 'firstSemesterStartDate' },
	{ label: 'RankingStartDate', key: 'rankingStartDate' },
	{ label: 'FirstSemesterExceptionExclusionDate', key: 'firstSemesterExceptionExclusionDate' },
	{ label: 'SecondSemesterStartDate', key: 'secondSemesterStartDate' },
	{ label: 'SecondSemesterExceptionExclusionDate', key: 'secondSemesterExceptionExclusionDate' },
	{ label: 'RankingEndDate', key: 'rankingEndDate' },
	{ label: 'RollOverDate', key: 'rollOverDate' },
	{ label: 'SportFrom', key: 'sportFrom' },
	{ label: 'OilSportTo', key: 'oilSportTo' },
	{ label: 'OilChallengeFrom', key: 'oilChallengeFrom' },
	{ label: 'OilChallengeTo', key: 'oilChallengeTo' },
	{ label: 'OilStandardFrom', key: 'oilStandardFrom' },
	{ label: 'OilStandardTo', key: 'oilStandardTo' },
    { label: 'MinT1Games', key: 'minT1Games' },
    { label: 'MinT2Games', key: 'minT2Games' },
	{ label: 'BakerToStandardGamesRatio', key: 'bakerToStandardGamesRatio' },
	{ label: 'MaxEventDuration', key: 'maxEventDuration' },
	{ label: 'MinWomenTeams', key: 'minWomenTeams' },
	{ label: 'MinMenTeams', key: 'minMenTeams' },
	{ label: 'MaxNumberNCAATeams', key: 'maxNumberNCAATeams' },
	{ label: 'MaxNumberNonNCAATeams', key: 'maxNumberNonNCAATeams' },
    { label: 'RosterMaxFirstSemester', key: 'rosterMaxFirstSemester' },
    { label: 'RosterMaxSecondSemester', key: 'rosterMaxSecondSemester' },
    { label: 'MinNumberTeamAthletesPerEvent', key: 'minNumberTeamAthletesPerEvent' },
    { label: 'MaxNumberTeamAthletesPerEvent', key: 'maxNumberTeamAthletesPerEvent' }
 ]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/seasonSettingsHeaders.js